import { DocumentNode, gql } from '@apollo/client';

const ADD_UNIT_MUTATION: DocumentNode = gql`
  mutation addUnit($groupId: Int! $unitName: String!) {
    unit {
      add(groupId: $groupId, unitName: $unitName) {
        groupId
        id
        name
      }
    }
  }
`;

export { ADD_UNIT_MUTATION };
